import { render, staticRenderFns } from "./ManagePartner.vue?vue&type=template&id=0497bcb2&"
import script from "./ManagePartner.vue?vue&type=script&lang=ts&"
export * from "./ManagePartner.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports